ACC.optin = {

  bindAll: function() {
    $('.ph-optinlink,.phi-optinlink ').click(function() {
      $.colorbox({
        maxWidth: '700px',
        width: '100%',
        scrolling: true,
        close: '<button type=\'button\' id=\'ph-cboxClose\' class=\'ph-favclose\'><span class=\'ph-icon-cross ph-favcross\'></span></button>',
        html: $('.ph-PopUpText').html(),
        onComplete: function() {
          ACC.common.refreshScreenReaderBuffer();
        },
        onClosed: function() {
          ACC.common.refreshScreenReaderBuffer();
        }
      });
    });
  }
};

$(document).ready(function() {
  ACC.optin.bindAll();
});


